
// SVG Icon: calendar
export default { id: "terriajs-calendar" };
export const id = "terriajs-calendar";
export const name = "calendar";
